import { render } from "./AuraChartBlock.vue?vue&type=template&id=582ed538&scoped=true&ts=true"
import script from "./AuraChartBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraChartBlock.vue?vue&type=script&setup=true&lang=ts"

import "./AuraChartBlock.vue?vue&type=style&index=0&id=582ed538&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582ed538"],['__file',"src/views/pages/aura/components/AuraChartBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "582ed538"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('582ed538', __exports__)) {
    api.reload('582ed538', __exports__)
  }
  
  module.hot.accept("./AuraChartBlock.vue?vue&type=template&id=582ed538&scoped=true&ts=true", () => {
    api.rerender('582ed538', render)
  })

}


export default __exports__